import { Autocomplete } from '@mantine/core'
import AutocompleteClasses from './styles.module.css'

export default Autocomplete.extend({
    defaultProps: { radius: 'lg' },
    classNames: AutocompleteClasses,
})
